import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=dd74acb2&scoped=true"
import script from "./Workplace.vue?vue&type=script&lang=js"
export * from "./Workplace.vue?vue&type=script&lang=js"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=dd74acb2&prod&lang=less&scoped=true"
import style1 from "./Workplace.vue?vue&type=style&index=1&id=dd74acb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd74acb2",
  null
  
)

export default component.exports